module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('h3', [_vm._v(_vm._s(_vm.$t('mission.slotTemplate.creator.title')))])]), _vm._v(" "), _c('div', [_c('b-form', {
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.createMissionSlotTemplate($event)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.title'),
      "state": _vm.missionSlotTemplateCreateTitleState,
      "feedback": _vm.missionSlotTemplateCreateTitleFeedback,
      "description": _vm.$t('mission.slotTemplate.title.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "required": ""
    },
    model: {
      value: (_vm.missionSlotTemplateCreateData.title),
      callback: function($$v) {
        _vm.missionSlotTemplateCreateData.title = $$v
      },
      expression: "missionSlotTemplateCreateData.title"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.visibility'),
      "state": _vm.missionSlotTemplateCreateVisibilityState,
      "feedback": _vm.missionSlotTemplateCreateVisibilityFeedback,
      "description": _vm.$t('mission.slotTemplate.visibility.description')
    }
  }, [_c('b-form-select', {
    staticClass: "mb-3",
    attrs: {
      "options": _vm.missionSlotTemplateCreateVisibilityOptions,
      "required": ""
    },
    model: {
      value: (_vm.missionSlotTemplateCreateData.visibility),
      callback: function($$v) {
        _vm.missionSlotTemplateCreateData.visibility = $$v
      },
      expression: "missionSlotTemplateCreateData.visibility"
    }
  })], 1)], 1)])])], 1), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('b-btn', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.createMissionSlotTemplate
    }
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.create.mission.slot.template')) + "\n    ")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3ec1a224"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/MissionSlotTemplateCreator.vue
// module id = 509
// module chunks = 0